import Text from '/src/components/@common.blocks/Text'

const AssetTraits = ({ traits = [], supply }) => {
  return (
    <div className='asset-traits'>
      <Text className='asset-traits__title'>Traits</Text>
      <div className='asset-traits__traits'>
        {traits.map((trait, key) => {
          const percent =
            supply && trait.count
              ? ((trait.count / supply) * 100).toFixed(2)
              : 0
          return (
            <div className='asset-traits__row' key={key}>
              <Text className='asset-traits__trait-type' color={'light-gray'}>
                {trait.traitType}
              </Text>
              <div className='asset-traits__trait-values'>
                <div>
                  <Text className='asset-traits__trait-value' component='span'>
                    {trait.traitValue}
                  </Text>
                </div>
                <div>
                  <div className='asset-traits__trait-score'>
                    <img src='/ui-icons/rarity-score.svg' alt='score' />
                    <Text component='span'>
                      {Number(trait.score).toFixed(2)}
                    </Text>
                  </div>
                  <Text component='span' color='secondary'>
                    {`${trait.count} (${percent}%)`}
                  </Text>
                </div>
              </div>
              <div className='asset-traits__indicator'>
                <div style={{ width: `${percent}%` }} />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AssetTraits
